/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import cn from 'clsx';
import { Breadcrumbs, Link } from '@material-ui/core';
import { Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ReactComponent as RequirementCheckSvg } from 'assets/icons/New/RequirementCheck.svg';
import { AButton, ASpin } from 'components/Antd';
import { getMomentDate } from 'util/date';
import ColumnActions from 'components/Antd/Table/ColumnActions';
import Notification from 'components/Notification';
import useDownloadFile from 'hooks/useDownloadFile';
import SetDatesModal from 'views/DocumentManagement/components/SetDatesModal';
import { useCreate } from 'context/ResourceProvider/hooks/useCreate';
import { useMe } from 'modules/company/hooks/useCompanySelector';
import useUploadFile from 'modules/inspection/hooks/useUploadDocument';
import AddDataModal from 'views/ProductDetail/Sections/ComplianceData/components/AddDataModal';
import AIInsight from './components/AIInsight';
import { ADD_CD_TAB_KEYS } from './components/AddCDModal/constants';
import RequirementEmpty from './components/Empty';
import RequirementBlock from './components/Block';
import AddModal from './components/AddModal';
import AddCDModal from './components/AddCDModal';
import { useData } from './hooks/useData';
import { getLinkCDPayload, isRequirementCompleted, getConfirmPDFPayload } from './utils';
import classes from './QualityRequirement.module.scss';
import {
  ModalListQualityRequirementTemplate,
  ModalSaveAsNewTemplate,
} from 'modules/product/components/QualityRequirementTemplate/index';
import { useDialog } from 'components/Molecules/hooks/useDialog/index';
import get from 'lodash/get';
import { List } from 'antd';
import { useListingModal } from 'components/Molecules/hooks/useListingModal/index';
import { useNavigateToDocumentReview } from './hooks/useProductNavigateToDocumentReview';

const QualityRequirementSection = ({ className, productId, reloadParentData, productDetail }) => {
  const today = getMomentDate('', true);
  const {
    getQualityRequirements,
    qualityRequirements,
    getTypeOptions,
    typeOptions,
    getNameOptions,
    nameOptions,
    addQualityRequirement,
    fetchLoading,
    linkDataToRequirement,
    deleteRequirementItem,
    deleteRequirementSubItem,
    completeRequirementItem,
    updateRequirementItem,
    duplicateRequirementItem,
    exportQualityRequirement,
  } = useData();
  const [listingModal, requirementSelectionContext] = useListingModal();
  const navigateToDocumentReview = useNavigateToDocumentReview();
  const { uploadFile } = useUploadFile();
  const [download] = useDownloadFile();
  const isChecked = isRequirementCompleted(qualityRequirements);
  const [modal, contextHolder] = Modal.useModal();
  const [isAdd, setIsAdd] = useState(false);
  const [editObj, setEditObj] = useState(null);
  const [addCBObj, setAddCBObj] = useState(null);
  const [exportFileObj, setExportFileObj] = useState(null);
  const [viewDataObj, setViewDataObj] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [notification, setNotification] = useState({ type: null, message: null });
  const [defaultExpandId, setDefaultExpandId] = useState(null);
  const [openQualityRequirementTemplate, setOpenQualityRequirementTemplate] = useState(null);
  const [showSaveAsNewTemplate, setShowSaveAsNewTemplate] = useState(false);
  const [openManageTemplate, setOpenManageTemplate] = useState(false);
  const saveAsTemplateFormRef = React.useRef();

  const isEmpty = !fetchLoading && qualityRequirements.length === 0;
  const { company } = useMe();
  const { showDialog, context: dialogContext } = useDialog();

  const { mutate } = useCreate({
    resource: 'document-list/document-list-index',
  });

  const { mutate: applyTemplate, loading: applyingTemplate } = useCreate({
    resource: 'products-quality-requirements-apply-template',
    meta: {
      params: {
        id: productId,
      },
    },
  });

  const { mutate: saveAsTemplate, loading: savingAsTemplate } = useCreate({
    resource: 'quality-requirements/templates',
  });

  const handleUploadFiles = async (tFiles) => {
    try {
      if (tFiles?.length) {
        const uploadedFiles = await uploadFile(tFiles, company.companyId);
        return (uploadedFiles || []).map(({ id }) => id);
      }
      return [];
    } catch (error) {
      return [];
    }
  };
  const handleConfirm = ({ title, description, submitText, isInfo }, cb) => {
    modal.confirm({
      title,
      icon: <></>,
      content: description,
      onOk() {
        if (cb) cb();
      },
      okText: submitText,
      closable: true,
      onCancel() {},
      centered: true,
      cancelButtonProps: {
        className: classes.cancelBtn,
      },
      className: cn(classes.warningModal, {
        [classes.infoModal]: isInfo,
      }),
      width: 500,
    });
  };
  const handleAddData = (tValues, cb) => {
    const tPayload = {
      customTypeId: tValues.type,
      customNameId: tValues.name,
      isMandatory: tValues.required?.[0] === 'required',
    };
    if (editObj) {
      updateRequirementItem(
        productId,
        editObj.typeObj.id,
        editObj.requirementObj.id,
        tPayload,
        (res) => {
          if (reloadParentData) reloadParentData();
          if (cb) cb();
          if (res.success) {
            setNotification({
              type: 'success',
              message: 'Requirement Item Edited',
            });
            setIsAdd(false);
            setEditObj(null);
          } else {
            setNotification({
              type: 'error',
              message: 'Failed to edit Requirement Item',
            });
          }
        }
      );
    } else {
      addQualityRequirement(productId, tPayload, (res) => {
        if (reloadParentData) reloadParentData();
        if (cb) cb();
        if (res.success) {
          setNotification({
            type: 'success',
            message: 'Requirement Created',
          });
          setIsAdd(false);
          setEditObj(null);
        } else {
          setNotification({
            type: 'error',
            message: 'Failed to create Requirement',
          });
        }
      });
    }
  };
  const handleSubAdd = (pObj, sObj) => {
    setAddCBObj({ pObj, sObj });
  };
  const handleLinkData = async (values, cb) => {
    const tPayload = getLinkCDPayload(values);
    linkDataToRequirement(productId, addCBObj?.pObj?.id, addCBObj?.sObj?.id, tPayload, (res) => {
      if (reloadParentData) reloadParentData();
      if (cb) cb();
      if (res.success) {
        setDefaultExpandId(addCBObj?.sObj?.id);
        setNotification({
          type: 'success',
          message: 'Data Added',
        });
        setAddCBObj(null);
      } else {
        setNotification({
          type: 'error',
          message: 'Failed to link data',
        });
      }
    });
  };
  const handleRemoveDataItem = (typeObj) => (requirementObj) => (dataObj) => {
    handleConfirm(
      {
        title: 'Are you sure to remove this data?',
        description: 'The action cannot be undone.',
        submitText: 'Remove',
      },
      async () => {
        deleteRequirementSubItem(
          productId,
          typeObj.id,
          requirementObj.id,
          dataObj.dataType === 'test'
            ? 'test-data'
            : dataObj.dataType === 'certificate'
            ? 'certificate-data'
            : 'other-data',
          dataObj.id,
          (res) => {
            if (reloadParentData) reloadParentData();
            if (res.success) {
              setNotification({
                type: 'success',
                message: 'Data Removed',
              });
              setAddCBObj(null);
            } else {
              setNotification({
                type: 'error',
                message: 'Failed to remove data',
              });
            }
          }
        );
      }
    );
  };
  const handleRemove = (typeObj) => (requirementObj) => () => {
    handleConfirm(
      {
        title: 'Are you sure to remove this requirement?',
        description: 'The action cannot be undone.',
        submitText: 'Remove',
      },
      async () => {
        deleteRequirementItem(productId, typeObj.id, requirementObj.id, (res) => {
          if (reloadParentData) reloadParentData();
          if (res.success) {
            setNotification({
              type: 'success',
              message: 'Requirement Removed',
            });
            setAddCBObj(null);
          } else {
            setNotification({
              type: 'error',
              message: 'Failed to remove requirement',
            });
          }
        });
      }
    );
  };
  const handleComplete = (typeObj) => (requirementObj) => (isRecordCompleted) => {
    completeRequirementItem(
      productId,
      typeObj.id,
      requirementObj.id,
      { isCompleted: !isRecordCompleted },
      (res) => {
        if (reloadParentData) reloadParentData();
        if (res.success) {
          setNotification({
            type: 'success',
            message: 'Requirement Completed',
          });
        } else {
          setNotification({
            type: 'error',
            message: 'Failed to complete requirement',
          });
        }
      }
    );
  };
  const handleEdit = (typeObj) => (requirementObj) => () => {
    setIsAdd(true);
    setEditObj({
      typeObj,
      requirementObj,
    });
  };
  const handleDuplicate = (typeObj) => (requirementObj) => () => {
    duplicateRequirementItem(productId, typeObj.id, requirementObj.id, (res) => {
      if (reloadParentData) reloadParentData();
      if (res.success) {
        setNotification({
          type: 'success',
          message: 'Requirement Duplicated',
        });
      } else {
        setNotification({
          type: 'error',
          message: 'Failed to duplicate requirement',
        });
      }
    });
  };
  const handleViewData = (typeObj) => (requirementObj) => (dataObj) => {
    // TODO: view data record
    setViewDataObj({
      typeObj,
      requirementObj,
      dataObj,
    });
  };
  const handleExport = () => {
    const fileName = `QualityRequirement_${productDetail.itemNo}_${today.format(
      'YYYYMMDD'
    )}_${today.format('HHmm')}`;
    setExportFileObj({
      name: fileName,
    });
  };
  const makeDownloadFile = (tFile, name) => {
    const url = window.URL.createObjectURL(tFile);
    download(name, url);
  };

  const handleApplyQualityRequirementTemplate = async (template) => {
    const onApply = async () => {
      try {
        await applyTemplate({
          qualityRequirementTemplateId: template.id,
        });
        setOpenQualityRequirementTemplate(false);
        setNotification({
          type: 'success',
          message: `${template.templateName} applied`,
        });
        getQualityRequirements(productId);
        getTypeOptions();
        getNameOptions();
      } catch (error) {
        setNotification({
          type: 'error',
          message: 'Failed to apply template',
        });
      }
    };

    if (Array.isArray(qualityRequirements) && qualityRequirements.length > 0) {
      showDialog('warning', {
        icon: <></>,
        title: 'Confirm Replacement ?',
        content: 'Confirm if you wish to replace the existing requirements with the template.',
        okText: 'Replace',
        onOk: () => {
          onApply();
        },
      });

      return;
    }
    onApply();
  };

  const handleSaveAsTemplate = async (values) => {
    const { templateName } = values;
    if (!templateName) return;

    const onSave = async () => {
      const payload = {
        templateName: templateName.label,
        requirements: qualityRequirements.map((item) => {
          return {
            name: get(item, 'customType.name'),
            items: item.items.map((subItem) => {
              return {
                itemName: get(subItem, 'customName.name'),
                isMandatory: subItem.isMandatory,
              };
            }),
          };
        }),
      };
      try {
        await saveAsTemplate(payload);
        setShowSaveAsNewTemplate(false);
        setNotification({
          type: 'success',
          message: 'Template saved',
        });
        getQualityRequirements(productId);
        getTypeOptions();
        getNameOptions();
      } catch (error) {
        setNotification({
          type: 'error',
          message: 'Failed to save template',
        });
      }
    };

    if (!templateName.isNew) {
      showDialog('warning', {
        icon: <></>,
        title: 'Replace the existing template ?',
        content: `A template with the same name ${templateName.label} already exists.`,
        okText: 'Replace',
        onOk: () => {
          onSave();
        },
      });
      return;
    }
    onSave();
  };

  const createDocumentReviewJob = (type) => () => {
    const flatRequirements = qualityRequirements.reduce((acc, item) => {
      // Mapper Following the Response Quality Requirement
      const { customType, items } = item;
      const mappedItems = items.map((subItem) => {
        const customTypeName = customType ? customType.name : '';
        const customName = subItem.customName ? subItem.customName.name : '';
        const label = customTypeName ? `${customTypeName} - ${customName}` : customName;
        return {
          label,
          value: label,
          data: { item: subItem, customType },
        };
      });
      return [...acc, ...mappedItems];
    }, []);
    listingModal.show({
      title: 'Select Quality Requirement',
      okText: `Confirm to ${type === 'create-job' ? 'Create Job' : 'Create Supplier Job'}`,
      cancelButtonProps: {
        hidden: true,
      },
      onOk: (selectedItems) => {
        navigateToDocumentReview(productDetail, selectedItems, {
          isSelfUpLoad: type === 'create-job',
        });
      },
      listConfig: {
        mode: 'select',
        dataSource: flatRequirements,
        valueKey: 'value',
        inputSearch: {
          placeholder: 'Search Quality Requirement',
          enterButton: null,
        },
        renderItem: (item, idx, { selected, onSelect, className }) => {
          return (
            <List.Item
              data-testid={`quality-requirement-item-${idx}`}
              className={className}
              extra={
                <AButton
                  type="primary"
                  ghost={!selected}
                  onClick={() => {
                    onSelect(item.value, item);
                  }}>
                  {selected ? 'Selected' : 'Select'}
                </AButton>
              }>
              <List.Item.Meta title={item.label} />
            </List.Item>
          );
        },
      },
    });
  };

  useEffect(() => {
    getQualityRequirements(productId);
    getTypeOptions();
    getNameOptions();
  }, []);

  return (
    <>
      <div className={cn(classes.wrapper, className)}>
        <Breadcrumbs separator={<NavigateNextIcon />} className={classes.breadcrumb}>
          <Link color="inherit" href="/product/list">
            Product List
          </Link>
          <span>Quality Requirement</span>
        </Breadcrumbs>
        <div className={classes.mainContent}>
          <div className={classes.header}>
            <h3>
              <span>Quality Requirement</span>
              <RequirementCheckSvg
                className={cn(classes.mainIcon, {
                  [classes.checked]: isChecked,
                })}
              />
              <AIInsight
                onExecuteAI={(tChecks) => {
                  if (reloadParentData) reloadParentData();
                  getQualityRequirements(productId);
                  getTypeOptions();
                  getNameOptions();
                  setNotification({
                    type: 'success',
                    message: 'AI Insight Data Added ',
                  });
                }}
                productDetail={productDetail}
                productId={productId}
              />
              <ColumnActions
                color="default"
                placement="bottomLeft"
                className={cn(classes.columnActions)}
                dropdownOverlay={classes.dropdownOverlay}
                defaultOpenKeys={['2']}
                items={[
                  {
                    key: '1',
                    label: <span>Import to Document Review</span>,
                    popupClassName: classes.subMenuOverlay,
                    children: [
                      {
                        key: '1-1',
                        label: <span>Create Job</span>,
                        onClick: createDocumentReviewJob('create-job'),
                      },
                      {
                        key: '1-2',
                        label: <span>Create Supplier Job</span>,
                        onClick: createDocumentReviewJob('create-supplier-job'),
                      },
                    ],
                  },
                  {
                    key: '2',
                    label: <span>Export As Document</span>,
                    onClick: handleExport,
                  },
                  {
                    key: '3',
                    label: <span>Templates</span>,
                    popupClassName: classes.subMenuOverlay,
                    children: [
                      {
                        key: '3-1',
                        label: <span>Apply Template</span>,
                        onClick: () => {
                          setOpenQualityRequirementTemplate(true);
                        },
                      },
                      {
                        key: '3-2',
                        label: <span>Save As Template</span>,
                        disabled: isEmpty,
                        onClick: () => {
                          setShowSaveAsNewTemplate(true);
                        },
                      },
                      {
                        key: '3-3',
                        label: <span>Manage Templates</span>,
                        onClick: () => {
                          setOpenManageTemplate(true);
                        },
                      },
                    ],
                  },
                ]}
              />
              {exportLoading && <ASpin indicator={<LoadingOutlined spin />} />}
            </h3>
            {!isEmpty && (
              <AButton
                type="primary"
                size="large"
                onClick={() => {
                  setIsAdd(true);
                }}>
                Add
              </AButton>
            )}
          </div>
          {isEmpty ? (
            <RequirementEmpty
              className={classes.empty}
              onAdd={() => {
                setIsAdd(true);
              }}
            />
          ) : (
            <div className={classes.blocks}>
              {qualityRequirements.map((obj, index) => {
                return (
                  <RequirementBlock
                    key={obj.id}
                    data={obj}
                    onSubAdd={(subObj) => {
                      handleSubAdd(obj, subObj);
                    }}
                    onRemoveDataItem={handleRemoveDataItem(obj)}
                    onRemove={handleRemove(obj)}
                    onComplete={handleComplete(obj)}
                    onEdit={handleEdit(obj)}
                    onDuplicate={handleDuplicate(obj)}
                    onViewData={handleViewData(obj)}
                    onResetExpandDefault={() => {
                      setDefaultExpandId(null);
                    }}
                    defaultExpandId={defaultExpandId}
                    indexKey={index}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
      {isAdd && (
        <AddModal
          open
          onClose={() => {
            setIsAdd(false);
            setEditObj(null);
          }}
          typeOptions={typeOptions}
          nameOptions={nameOptions}
          reloadTypeOptions={(cb) => {
            getTypeOptions(cb);
          }}
          reloadNameOptions={(cb) => {
            getNameOptions(cb);
          }}
          onSubmit={handleAddData}
          editObj={editObj}
        />
      )}
      {!!addCBObj && (
        <AddCDModal
          open
          onClose={() => {
            setAddCBObj(null);
          }}
          onSubmit={handleLinkData}
          productId={productId}
          existingObj={addCBObj}
        />
      )}
      {!!exportFileObj && (
        <SetDatesModal
          open
          onClose={() => {
            setExportFileObj(null);
          }}
          onSubmit={async (values, tFileType) => {
            const tFileName = `${exportFileObj.name}.${tFileType}`;
            setExportLoading(true);
            exportQualityRequirement(productId, tFileType, async (res) => {
              if (res?.data) {
                const tFile = new Blob([res.data], {
                  type: `application/${
                    tFileType === 'pdf'
                      ? 'pdf'
                      : 'vnd.openxmlformats-officedocument.wordprocessingml.document'
                  }`,
                });
                const tUploadFile = new File([tFile], tFileName, {
                  type: tFile.type,
                });
                const documentListIds = await handleUploadFiles([tUploadFile]);
                const payload = getConfirmPDFPayload(productId, documentListIds, values);
                try {
                  await mutate(payload);
                  setExportFileObj(null);
                  setExportLoading(false);
                  handleConfirm(
                    {
                      title: 'Document Saved',
                      description:
                        'The generated document has been downloaded to your device and is also available on the Document page for this product.',
                      isInfo: true,
                    },
                    () => {}
                  );
                  makeDownloadFile(tUploadFile, tFileName);
                } catch (error) {
                  setExportLoading(false);
                  setNotification({
                    type: 'error',
                    message: 'Failed to download',
                  });
                }
              } else {
                setExportLoading(false);
                setNotification({
                  type: 'error',
                  message: 'Failed to download',
                });
              }
            });
          }}
          defaultSelectedDocument={{}}
          editableFile={exportFileObj}
          submitLoading={exportLoading}
        />
      )}
      {!!viewDataObj && (
        <AddDataModal
          open
          action={''}
          title={
            viewDataObj?.dataObj?.dataType === ADD_CD_TAB_KEYS.TEST
              ? 'Test Data'
              : viewDataObj?.dataObj?.dataType === ADD_CD_TAB_KEYS.CERTIFICATE
              ? 'Certificate Data'
              : 'Other Data'
          }
          onClose={() => {
            setViewDataObj(null);
          }}
          editObj={{}}
          viewObj={viewDataObj}
          issuePartyOptions={[]}
          existingDocuments={[]}
          onSubmit={() => {}}
          reloadIssuePartyOptions={() => {}}
          complianceTypeOptions={[]}
          reloadComplianceTypes={() => () => {}}
          scoreOptions={[]}
          reloadScoreOptions={() => {}}
          otherComplianceTypeOptions={[]}
        />
      )}
      <ModalListQualityRequirementTemplate
        title="Apply Template"
        destroyOnClose
        width={528}
        footer={false}
        loading={applyingTemplate}
        open={openQualityRequirementTemplate}
        onCancel={() => {
          setOpenQualityRequirementTemplate(false);
        }}
        onApplyTemplate={(template) => {
          handleApplyQualityRequirementTemplate(template);
        }}
      />
      <ModalListQualityRequirementTemplate
        title="Manage Template"
        destroyOnClose
        width={528}
        footer={false}
        manageable
        loading={applyingTemplate}
        open={openManageTemplate}
        onCancel={() => {
          setOpenManageTemplate(false);
        }}
      />
      <ModalSaveAsNewTemplate
        title="Save As Template"
        destroyOnClose
        loading={savingAsTemplate}
        open={showSaveAsNewTemplate}
        childRef={saveAsTemplateFormRef}
        onCancel={() => {
          setShowSaveAsNewTemplate(false);
        }}
        cancelButtonProps={{
          hidden: true,
        }}
        okText="Confirm"
        onOk={() => {
          saveAsTemplateFormRef.current.submit();
        }}
        onSubmit={handleSaveAsTemplate}
      />
      {contextHolder}
      {dialogContext}
      {requirementSelectionContext}
      <Notification
        notification={notification}
        onClose={() => setNotification({ type: null, message: null })}
        handleOnClose={() => setNotification({ type: null, message: null })}
      />
    </>
  );
};

export default QualityRequirementSection;
